export enum SelectedDimensionTabEnum {
  OTP = "onTimePerformance",
  TURNAROUND_SUFFICIENCY = "turnaroundSufficiency",
  RUNWAY_DELAY = "runwayDelay",
  SLOT_ADHERENCE = "slotAdherence",
}
